import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=57170b75&scoped=true&"
import script from "./sso.vue?vue&type=script&lang=js&"
export * from "./sso.vue?vue&type=script&lang=js&"
import style0 from "./sso.vue?vue&type=style&index=0&id=57170b75&lang=scss&scoped=true&"
import style1 from "./sso.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57170b75",
  null
  
)

export default component.exports